import theme from '../../../lib/theme';
import { MembershipChallengeProps } from './MembershipChallenge';

const {
  layouts,
  corners,
  scale,
  colors,
  media,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default () => ({

  container: {
    ...layouts.column,
		justifyContent: 'center',
    display: 'flex',
		backgroundColor: 'rgba(101, 31, 255, 0.1)',
		padding: '20px',
    gap: scale.xs,
	},
	title: {
		display: 'block',
		fontSize: '20px !important',
		margin: '0 !important',
		lineHeight: 'unset !important',
  },
	subtitle: {

	},
  form: {
    '> .form-row': {
      [media.m.down]: {
        display: 'flex',
        gap: scale.xxxs,
      },  
    }
  }
});
